export default "__VITE_ASSET__304376eb__"